import { AppInfoList, AppWidget } from '@launchpad';
import { AppPadding } from '@launchpad/components/widgets/AppPadding';
import Api from '@launchpad/logic/api/Api';
import React, { useEffect } from 'react';

const StipLogStats = () => {
  const [status, setStatus] = React.useState<any>(null);

  useEffect(() => {
    // Fetch stats data from API or other source
    const fetchStatus = async () => {
      const data = (await Api.call(
        'admin/temenos/stip-log/status',
        'GET'
      )) as any;
      if (data.data) {
        setStatus(data.data);
      }
    };
    fetchStatus();
  }, []);

  if (!status) return <p>Loading...</p>;

  const statusItems = [
    {
      label: 'STIP Enabled for all',
      value: status.status.enabled ? 'Yes' : 'No',
    },
    {
      label: 'STIP Enabled for tokens',
      value:
        status.status.enabledForTokens &&
        status.status.enabledForTokens.length > 0
          ? status.status.enabledForTokens.join(',')
          : '-',
    },
  ];

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <AppWidget title="Status">
          <AppPadding>
            <AppInfoList items={statusItems} />
          </AppPadding>
        </AppWidget>
      </div>

      <AppWidget title="Stats">
        <AppPadding>
          {status.stats.length === 0 && <p>No stats available.</p>}
          {status.stats.map((item) => {
            return (
              <div key={item.period} style={{ marginBottom: 20 }}>
                <h5>{item.period}:</h5>
                <hr />
                <AppInfoList
                  items={item.items.map((x: any) => ({
                    label: x.label,
                    value:
                      typeof x.value === 'number' && !Number.isInteger(x.value)
                        ? Math.round(x.value * 100) / 100
                        : x.value,
                  }))}
                />
              </div>
            );
          })}
        </AppPadding>
      </AppWidget>
    </>
  );
};

export default StipLogStats;
